/*
 * cc-cart-drawer.js — behaviour for sections/cc-cart-drawer.liquid
 * (the Cocosutra cart drawer ported to the Trynutty / Kalles t4s theme).
 *
 * - Opens/closes the <dialog> with the same slide + backdrop animation as Cocosutra.
 * - Takes over the theme's mini-cart: header cart icon clicks and the
 *   "open drawer after add to cart" action open this drawer instead of #t4s-mini_cart.
 * - Quantity +/-, remove, discount codes and "You may also like" add-to-cart
 *   all go through the Ajax Cart API with Section Rendering, so the drawer
 *   re-renders from Liquid (no client-side templating).
 */
(function () {
  'use strict';
  if (window.CCCartDrawer) return;

  var SECTION_ID = 'cc-cart-drawer';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EASE = 'cubic-bezier(0.19, 1, 0.22, 1)';
  var html = document.documentElement;
  var recsCache = {};
  var ignoreThemeUpdateUntil = 0;
  var qtyTimers = {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function root() { return document.querySelector('[data-cc-cart-root]'); }
  function dialog() { return document.getElementById('CartDrawer'); }
  function isRTL() { return document.dir === 'rtl' || html.classList.contains('dir--rtl'); }

  function postJSON(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
    });
  }

  /* ---------------- open / close ---------------- */
  var isAnimating = false;
  function open() {
    var d = dialog();
    if (!d || d.open) return;
    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
    html.setAttribute('scroll-lock', '');
    d.classList.add('dialog-opening');
    var from = 'translate3d(' + (isRTL() ? '-' : '') + '100%, 0, 0)';
    var anim = d.animate ? d.animate([{ transform: from }, { transform: 'translate3d(0, 0, 0)' }], { duration: 500, easing: EASE }) : null;
    var done = function () { d.classList.remove('dialog-opening'); };
    anim ? (anim.onfinish = done) : done();
    loadRecommendations();
  }
  function close() {
    var d = dialog();
    if (!d || !d.open || isAnimating) return;
    isAnimating = true;
    d.classList.add('dialog-closing');
    var to = 'translate3d(' + (isRTL() ? '-' : '') + '100%, 0, 0)';
    var finish = function () {
      d.close ? d.close() : d.removeAttribute('open');
      d.classList.remove('dialog-closing');
      html.removeAttribute('scroll-lock');
      isAnimating = false;
    };
    if (d.animate) {
      var anim = d.animate([{ transform: 'translate3d(0, 0, 0)' }, { transform: to }], { duration: 400, easing: EASE, fill: 'forwards' });
      anim.onfinish = function () { finish(); anim.cancel(); };
    } else finish();
  }

  /* ---------------- rendering ---------------- */
  function applySection(htmlString) {
    if (!htmlString) return;
    var doc = new DOMParser().parseFromString(htmlString, 'text/html');
    var nd = doc.getElementById('CartDrawer');
    var d = dialog();
    if (!nd || !d) return;
    var oldScroll = $('[data-hdt-scroll-me]', d);
    var scrollTop = oldScroll ? oldScroll.scrollTop : 0;
    var recs = $('cc-cart-recommendations', d);
    var recsUrl = recs && recs.getAttribute('data-url');

    d.className = nd.className;
    var nh = $('.hdt-dialog-drawer__header', nd), oh = $('.hdt-dialog-drawer__header', d);
    if (nh && oh) oh.innerHTML = nh.innerHTML;
    var ni = $('.hdt-dialog-drawer__inner', nd), oi = $('.hdt-dialog-drawer__inner', d);
    if (ni && oi) oi.innerHTML = ni.innerHTML;

    // keep the already-loaded recommendations when the product they are based on did not change
    var newRecs = $('cc-cart-recommendations', d);
    if (newRecs && recs && recsUrl && newRecs.getAttribute('data-url') === recsUrl && recs.children.length) {
      newRecs.replaceWith(recs);
    }
    var ns = $('[data-hdt-scroll-me]', d);
    if (ns) ns.scrollTop = scrollTop;

    var nw = doc.querySelector('hdt-cart-drawer');
    var count = nw ? parseInt(nw.getAttribute('data-count'), 10) || 0 : 0;
    var ow = document.querySelector('hdt-cart-drawer');
    if (ow) ow.setAttribute('data-count', count);
    syncCount(count);
    loadRecommendations();
  }

  function syncCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var mini = document.getElementById('t4s-mini_cart');
    if (mini) mini.setAttribute('data-ccount', count);
    $$('.t4s-cart-count-0').forEach(function (el) { if (count > 0) el.classList.remove('t4s-cart-count-0'); });
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { applySection(j[SECTION_ID]); })
      .catch(function (e) { console.error('[cc-cart-drawer] refresh failed', e); });
  }

  // Let the rest of the Trynutty theme (header count, hidden mini cart, sticky ATC…) know the cart changed.
  function notifyTheme() {
    ignoreThemeUpdateUntil = Date.now() + 3000;
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function loadRecommendations() {
    var el = $('cc-cart-recommendations[data-url]', dialog() || document);
    if (!el) return;
    var url = el.getAttribute('data-url');
    if (!url || el.getAttribute('data-loaded') === url) return;
    var render = function (markup) {
      var doc = new DOMParser().parseFromString(markup, 'text/html');
      var fresh = doc.querySelector('cc-cart-recommendations');
      var cur = $('cc-cart-recommendations[data-url]', dialog() || document);
      if (!fresh || !cur) return;
      cur.innerHTML = fresh.innerHTML;
      cur.setAttribute('data-loaded', url);
    };
    if (recsCache[url]) return render(recsCache[url]);
    fetch(url).then(function (r) { return r.text(); }).then(function (t) { recsCache[url] = t; render(t); })
      .catch(function (e) { console.error('[cc-cart-drawer] recommendations failed', e); });
  }

  /* ---------------- cart actions ---------------- */
  function busy(on) {
    var c = $('cart-items-component', dialog());
    if (c) c.classList.toggle('cart-items-disabled', on);
  }

  function changeLine(line, quantity, animateRemove) {
    busy(true);
    return postJSON('cart/change.js', { line: line, quantity: quantity, sections: SECTION_ID, sections_url: window.location.pathname })
      .then(function (res) {
        if (!res.ok || res.data.errors || res.data.status) {
          var row = $('hdt-line-item[data-line="' + line + '"]', dialog());
          var input = row && $('[data-cc-qty-input]', row);
          if (input) {
            input.classList.add('hdt-quantity-max-reached');
            setTimeout(function () { input.classList.remove('hdt-quantity-max-reached'); }, 3500);
          }
          return refresh();
        }
        var p = Promise.resolve();
        if (animateRemove) {
          var row2 = $('hdt-line-item[data-line="' + line + '"]', dialog());
          if (row2 && row2.animate) {
            row2.style.overflow = 'hidden';
            p = row2.animate([
              { opacity: 1, height: row2.clientHeight + 'px' },
              { opacity: 0, height: '0px', paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0, borderColor: 'transparent' }
            ], { duration: 250, easing: 'ease-in-out', fill: 'forwards' }).finished;
          }
        }
        return p.then(function () {
          applySection(res.data.sections && res.data.sections[SECTION_ID]);
          notifyTheme();
        });
      })
      .catch(function (e) { console.error('[cc-cart-drawer] change failed', e); })
      .then(function () { busy(false); });
  }

  function applyDiscount(codes, errEl, input) {
    busy(true);
    return postJSON('cart/update.js', { discount: codes, sections: SECTION_ID })
      .then(function (res) {
        var list = (res.data && res.data.discount_codes) || [];
        var entered = input ? input.value.trim().toLowerCase() : '';
        var entry = list.filter(function (d) { return d.code.toLowerCase() === entered; })[0] || list[0];
        if (input && entered && (!res.ok || !entry || !entry.applicable)) {
          if (errEl) errEl.style.display = 'block';
          input.value = '';
          // drop the rejected code again so it does not linger on the cart
          var keep = (input.getAttribute('data-value') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          postJSON('cart/update.js', { discount: keep.join(','), sections: SECTION_ID }).then(function () { busy(false); });
          return;
        }
        if (errEl) errEl.style.display = 'none';
        applySection(res.data.sections && res.data.sections[SECTION_ID]);
        notifyTheme();
        busy(false);
      })
      .catch(function (e) {
        console.error('[cc-cart-drawer] discount failed', e);
        if (errEl) { errEl.textContent = 'Error applying discount code'; errEl.style.display = 'block'; }
        busy(false);
      });
  }

  function addToCart(form) {
    var btn = $('button[type="submit"]', form);
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    postJSON('cart/add.js', {
      items: [{ id: Number(idInput.value), quantity: qtyInput ? Number(qtyInput.value) || 1 : 1 }],
      sections: SECTION_ID, sections_url: window.location.pathname
    }).then(function (res) {
      if (!res.ok || res.data.status) {
        console.error('[cc-cart-drawer] add failed', res.data && res.data.description);
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        return;
      }
      applySection(res.data.sections && res.data.sections[SECTION_ID]);
      notifyTheme();
    }).catch(function (e) {
      console.error('[cc-cart-drawer] add failed', e);
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  }

  /* ---------------- events inside the drawer ---------------- */
  document.addEventListener('click', function (e) {
    var d = dialog();
    if (!d || !d.contains(e.target)) return;

    // backdrop click (the dialog element itself, outside its box)
    if (e.target === d) {
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { close(); return; }
    }
    if (e.target.closest('[data-cc-close]')) { e.preventDefault(); close(); return; }

    var qtyBtn = e.target.closest('[data-cc-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var row = qtyBtn.closest('hdt-line-item');
      var input = $('[data-cc-qty-input]', row);
      var before = input.value;
      qtyBtn.getAttribute('data-cc-qty') === 'plus' ? input.stepUp() : input.stepDown();
      var max = parseInt(input.max, 10);
      if (parseInt(before, 10) === max && parseInt(input.value, 10) === max) {
        input.classList.add('hdt-quantity-max-reached');
        setTimeout(function () { input.classList.remove('hdt-quantity-max-reached'); }, 3500);
      }
      if (before !== input.value) queueQty(row, input);
      return;
    }

    var remove = e.target.closest('[data-cc-remove]');
    if (remove) {
      e.preventDefault();
      var rrow = remove.closest('hdt-line-item');
      changeLine(Number(rrow.getAttribute('data-line')), 0, true);
      return;
    }

    var apply = e.target.closest('[data-cart-discount-apply]');
    if (apply) {
      e.preventDefault();
      var wrap = apply.closest('hdt-cart-discount');
      var dInput = $('[data-cart-discount-input]', wrap);
      var code = dInput.value.trim();
      if (!code) return;
      var existing = (dInput.getAttribute('data-value') || '').trim();
      applyDiscount(existing ? code + ',' + existing : code, $('[data-cart-discount-error]', wrap), dInput);
      return;
    }

    var rm = e.target.closest('.hdt-discount-remove');
    if (rm) {
      e.preventDefault();
      var codeToRemove = rm.getAttribute('data-discount-code');
      var inp = $('[data-cart-discount-input]', d);
      var codes = ((inp && inp.getAttribute('data-value')) || '').split(',').map(function (s) { return s.trim(); })
        .filter(function (s) { return s && s !== codeToRemove; });
      applyDiscount(codes.join(','), null, null);
      return;
    }

    var checkout = e.target.closest('.hdt-mini-cart__btn-checkout');
    if (checkout) {
      // same as Cocosutra: close the drawer once the checkout handler has run
      setTimeout(close, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = dialog();
    if (!d || !d.contains(e.target)) return;
    if (e.key === 'Enter' && e.target.matches('[data-cart-discount-input]')) {
      e.preventDefault();
      var btn = $('[data-cart-discount-apply]', e.target.closest('hdt-cart-discount'));
      if (btn) btn.click();
    }
  });

  document.addEventListener('change', function (e) {
    var d = dialog();
    if (!d || !d.contains(e.target) || !e.target.matches('[data-cc-qty-input]')) return;
    queueQty(e.target.closest('hdt-line-item'), e.target, 0);
  });

  function queueQty(row, input, delay) {
    var line = Number(row.getAttribute('data-line'));
    clearTimeout(qtyTimers[line]);
    qtyTimers[line] = setTimeout(function () {
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(line, q, q === 0);
    }, delay == null ? 300 : delay);
  }

  document.addEventListener('submit', function (e) {
    var d = dialog();
    if (!d || !d.contains(e.target)) return;
    if (e.target.matches('.cc-cart-recs form, form.cc-card13__form')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(e.target);
    }
  }, true);

  // Esc: animate out instead of the native instant close
  document.addEventListener('cancel', function (e) {
    if (e.target === dialog()) { e.preventDefault(); close(); }
  }, true);

  /* ---------------- take over the theme's mini cart ---------------- */
  // Header / toolbar cart icons point at #t4s-mini_cart through data-drawer-options.
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-drawer-options*="t4s-mini_cart"]');
    if (!t || !dialog()) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    open();
  }, true);

  // After add-to-cart the theme calls T4SThemeSP.Drawer.opend($('#t4s-mini_cart')).
  function patchThemeDrawer() {
    var sp = window.T4SThemeSP;
    if (!sp || !sp.Drawer || !sp.Drawer.opend || sp.Drawer.__ccPatched) return !!(sp && sp.Drawer && sp.Drawer.__ccPatched);
    var orig = sp.Drawer.opend;
    sp.Drawer.opend = function (target) {
      var el = target && (target.jquery ? target[0] : target);
      if (el && el.id === 't4s-mini_cart' && dialog()) {
        ignoreThemeUpdateUntil = Date.now() + 1500;
        refresh().then(open);
        return;
      }
      return orig.apply(this, arguments);
    };
    sp.Drawer.__ccPatched = true;
    return true;
  }
  if (!patchThemeDrawer()) {
    var tries = 0;
    var iv = setInterval(function () { if (patchThemeDrawer() || ++tries > 100) clearInterval(iv); }, 100);
  }

  // Any other cart change made by the theme (product page ATC, quick view, sticky ATC…)
  document.addEventListener('cart:updated', function (e) {
    if (Date.now() < ignoreThemeUpdateUntil) return;
    var w = document.querySelector('hdt-cart-drawer');
    var current = w ? parseInt(w.getAttribute('data-count'), 10) : NaN;
    var next = e && e.detail ? parseInt(e.detail.count, 10) : NaN;
    if (!isNaN(next) && next === current) return; // nothing changed (e.g. the theme's initial mini-cart load)
    refresh();
  });

  function init() {
    var w = document.querySelector('hdt-cart-drawer[data-open-on-cart-page="true"]');
    if (w) setTimeout(open, 0);
    loadRecommendations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.CCCartDrawer = { open: open, close: close, refresh: refresh };
})();
